import { useEffect, useState } from 'react';

/* Совпадает ли медиазапрос прямо сейчас — и обновляется при повороте экрана
   или изменении размера окна. Нужен там, где от ширины зависит не стиль, а
   сам текст (например, подсказка в поле). */
export default function useMedia(query) {
  const read = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(read);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', onChange); else mq.removeListener(onChange); };
  }, [query]);

  return matches;
}
